import { render, staticRenderFns } from "./EmptyCartView.vue?vue&type=template&id=70d502f1&"
import script from "./EmptyCartView.vue?vue&type=script&lang=ts&"
export * from "./EmptyCartView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EmptyCartView.vue"
export default component.exports